module.exports = __webpack_public_path__ + "static/assets/1696783c07a3b7038e113bb679e60991.png";